/**
 * The decorative line-art motif for a scenario (see content/scenarioArt.ts).
 *
 * Rendered in normal flow, centred in the right column directly beneath the "Proceed to the options"
 * box, so it sits in the same place on every scenario (no absolute positioning / overflow clipping,
 * which previously sliced the icon). Purely decorative: aria-hidden. Shown on sm+ only (it would
 * crowd the dense prose on the narrowest screens). Thin stroke + low opacity = a quiet watermark that
 * never competes with the legal text. Appears during the "Proceed" step of each scenario.
 */
import { SCENARIO_ART } from "../content/scenarioArt";

export function ScenarioArt({ scenarioId }: { scenarioId: string }) {
  const Icon = SCENARIO_ART[scenarioId];
  if (!Icon) return null;
  return (
    <div aria-hidden="true" className="mt-10 hidden justify-center text-ink-950 opacity-[0.12] sm:flex">
      <Icon size={240} strokeWidth={1.5} aria-hidden="true" />
    </div>
  );
}
